import script from "./GenericCard.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericCard.vue?vue&type=script&setup=true&lang=js"

import "./GenericCard.vue?vue&type=style&index=0&id=39550eb6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39550eb6"]])

export default __exports__